import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useRoutes
} from "react-router-dom";
import { addToAclList } from "../data/redux/slice/aclSlice";
import { authSliceReducerSlice } from "../data/redux/slice/authSlice";
import { clearDashboardFilter } from "../data/redux/slice/countsSlice";
import { clearGlobalFilterReducer } from "../data/redux/slice/globalFiltersSlice";
import ApprovalIndex from "../presentation/components/ui_comps/approval_comps";
import ForgotPasswordIndex from "../presentation/pages/auth_pages/forgot_password";
import LoginIndex from "../presentation/pages/auth_pages/login";
import ApiDocIndex from "../presentation/pages/main_pages/api_doc";
import ApprovalMainIndex from "../presentation/pages/main_pages/approval";
import RncValidator from "../presentation/pages/main_pages/approval/RncValidator";
import ClientIndex from "../presentation/pages/main_pages/clients";
import ClientOnboardNew from "../presentation/pages/main_pages/clients/ClientOnboradNew";
import ClientDetailsIndex from "../presentation/pages/main_pages/clients/client_details";
import CommissionListIndex from "../presentation/pages/main_pages/commission_list";
import CustomerCenterIndex from "../presentation/pages/main_pages/customer_center";
import DashboardIndex from "../presentation/pages/main_pages/dashboard";
import ResellerIndex from "../presentation/pages/main_pages/reseller";
import ResellerDetailsIndex from "../presentation/pages/main_pages/reseller/reseller_details";
import RoleManagementIndex from "../presentation/pages/main_pages/role_management";
import RoleManagementDetailsIndex from "../presentation/pages/main_pages/role_management/basic_details_role_management";

import SettlementIndex from "../presentation/pages/main_pages/settlement";
import TransactionIndex from "../presentation/pages/main_pages/transaction";
import {
  fetchAllRoleCounts,
  fetchCashfreeBalanceOfClient,
  fetchClientAccount,
  fetchClientSecretId,
  fetchTransactionList,
  getAllDashboardTransactionCount,
  getAllDashboardVolumeCount,
  getAllSettlementCount,
  updateMainTransactions
} from "../services/fetchListingData";
import { storeAllAcls } from "../services/loginService";
import secureStorage from "../services/secureStorage";
import {
  SS_ACLS,
  SS_AUTH_TOKEN,
  SS_ROLE,
  SS_INTERNAL,
  SS_USER_HASH_ID,
  SS_WHITELISTED_LOGO,
  SS_WHITELISTED_URL
} from "../utility/constants/secureStorageManager";
import {
  CLIENT,
  DASHBOARD_ACL,
  STATUS_CODE_200,
  VAN_ACL
} from "../utility/constants/valueConstants";
import VanDashbaordIndex from "../presentation/pages/main_pages/van/dashboard/Dashboard";
import VanTransactionIndex from "../presentation/pages/main_pages/van/transaction/Transaction";
import VanCustomersIndex from "../presentation/pages/main_pages/van/customers/Customers";
import VanFinanceIndex from "../presentation/pages/main_pages/van/finance/Finance";
import ClientAddService from "../presentation/pages/main_pages/clients/addServices";
import ClientSettlementINdex from "../presentation/pages/main_pages/client_settlement";
import ClientSettlementIndex from "../presentation/pages/main_pages/client_settlement";
import RiskManagementIndex from "../presentation/pages/main_pages/risk_management";
import CustomerDetailsIndex from "../presentation/pages/main_pages/risk_management/customer_details";
import VanCustomerIndex from "../presentation/pages/main_pages/customers";
import SupportIndex from "../presentation/pages/main_pages/support";
import Verified2fa from "../presentation/pages/auth_pages/verification/Verified2fa";
import EditAcl from "../presentation/pages/main_pages/clients/client_details/EditAcl";
import CreatePasswordIndex from "../presentation/pages/auth_pages/create_password";
import { ApiRequestGet } from "../data/network/services/ApiRequestGet";
import { addLogoToUrl } from "../data/redux/slice/logoSlice";
import CouponIndex from "../presentation/pages/main_pages/coupons";
import { addCashfreeBal } from "../data/redux/slice/listingDataSlice";

function RouteIndex() {
  const dispatch = useDispatch();
  const authenticated = useSelector(
    (state) => state.authSliceReducer.isAuthenticated
  );
  const reduxLogo = useSelector((state) => state.logoSlice);
  const role = secureStorage.getItem(SS_ROLE);

  const aclData = useSelector((state) => state.aclSlice.aclList);

  const location = useLocation();

  const [isVanDashboard, setVanDashboard] = useState(false);
  const internal = secureStorage.getItem(SS_INTERNAL);

  const checkForUserLoggedIn = async () => {
    const token = await secureStorage.getItem(SS_AUTH_TOKEN);
    const id = await secureStorage.getItem(SS_USER_HASH_ID);
    const data = await secureStorage.getItem(SS_ACLS);

    if (data) {
      const aclValues = data.map((item) => item?.acl_value);
      const isVanAcl = aclValues.includes(VAN_ACL);
      const isDashboardAcl = aclValues.includes(DASHBOARD_ACL);

      if (isVanAcl && !isDashboardAcl) {
        setVanDashboard(true);
      }
    }

    if (id && token) {
      dispatch(authSliceReducerSlice(true));
    }

    dispatch(addToAclList(storeAllAcls(data)));
  };

  useEffect(() => {
    checkForUserLoggedIn();
    if (authenticated && internal) {
      dispatch(fetchAllRoleCounts());
      dispatch(
        getAllDashboardVolumeCount({
          clientId: "",
          resellerId: "",
          rootReferenceId: ""
        })
      );
      dispatch(
        getAllDashboardTransactionCount({
          clientId: "",
          resellerId: "",
          rootReferenceId: ""
        })
      );
      dispatch(
        getAllSettlementCount({
          dateRange: "",
          serviceType: "",
          userId: "",
          userRefId: ""
        })
      );
      dispatch(
        updateMainTransactions({
          clientId: "",
          resellerId: "",
          rootReferenceId: ""
        })
      );
      if (role === CLIENT) {
        dispatch(fetchClientSecretId());
        dispatch(fetchClientAccount({}));
      }
    }
  }, []);

  useEffect(() => {
    dispatch(clearGlobalFilterReducer());
    dispatch(clearDashboardFilter());
  }, [location]);

  const getLogoUrlFromDomain = (url) => {
    ApiRequestGet.fetchLogoUrlFromDomailUrl({ url })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(addLogoToUrl(res.data.whiteLabelLogoUrl));
          secureStorage.setItem(
            SS_WHITELISTED_LOGO,
            res.data.whiteLabelLogoUrl
          );
        }
      })
      .catch((e) => {})
      .finally(() => {
        secureStorage.setItem(SS_WHITELISTED_URL, url);
      });
  };

  useEffect(() => {
    // getLogoUrlFromDomain();
    let url = window.location.host;
    const logo = secureStorage.getItem(SS_WHITELISTED_LOGO);
    if (!logo) {
      getLogoUrlFromDomain(url);
    }

    if (logo) {
      dispatch(addLogoToUrl(logo));
    }
  }, [authenticated]);

  useEffect(() => {
    if (reduxLogo?.logo) {
      var link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = reduxLogo?.logo;
    }
  }, [reduxLogo]);

  const Clientid = secureStorage.getItem(SS_USER_HASH_ID);
  useEffect(() => {
    if (Clientid) {
      dispatch(fetchCashfreeBalanceOfClient(Clientid));
    }
  }, [Clientid]);

  return (
    <Routes>
      {authenticated ? (
        <>
          {isVanDashboard ? (
            <>
              <Route path="*" element={<Navigate to="/van/dashboard" />} />
              <Route path="support" element={<SupportIndex />} />
              <Route path="/api-doc" element={<ApiDocIndex />} />
              {!internal && (
                <Route exact path="clients">
                  <Route index={true} element={<ClientIndex />} />
                  <Route path="details" element={<ClientDetailsIndex />} />
                </Route>
              )}
            </>
          ) : (
            <>
              <Route path="*" element={<Navigate to="/dashboard" />} />
              <Route path="/dashboard" element={<DashboardIndex />} />{" "}
              <Route path="/transaction" element={<TransactionIndex />} />
              <Route exact path="/approval/list">
                <Route index={true} element={<ApprovalMainIndex />} />
                <Route path="details" element={<RncValidator />} />
              </Route>
              <Route exact path="reseller">
                <Route index={true} element={<ResellerIndex />} />
                <Route path="details" element={<ResellerDetailsIndex />} />
              </Route>
              <Route exact path="coupons">
                <Route index={true} element={<CouponIndex />} />
              </Route>
              <Route exact path="clients">
                <Route index={true} element={<ClientIndex />} />
                <Route path="details" element={<ClientDetailsIndex />} />
                <Route path="onboard" element={<ClientOnboardNew />} />
                <Route path="addservice" element={<ClientAddService />} />
                <Route path="edit-acl" element={<EditAcl />} />
              </Route>
              <Route path="support" element={<SupportIndex />} />
              <Route
                path="client-settlement"
                element={<ClientSettlementIndex />}
              />
              <Route path="customer-list" element={<VanCustomerIndex />} />
              <Route exact path="risk-management">
                <Route index={true} element={<RiskManagementIndex />} />
                <Route path="details" element={<CustomerDetailsIndex />} />
              </Route>
              <Route path="/commission" element={<CommissionListIndex />} />
              <Route path="/finance" element={<SettlementIndex />} />
              <Route exact path="role-management">
                <Route index={true} element={<RoleManagementIndex />} />
                <Route
                  path="details"
                  element={<RoleManagementDetailsIndex />}
                />
              </Route>
              <Route path="/customer" element={<CustomerCenterIndex />} />
              <Route path="/api-doc" element={<ApiDocIndex />} />
            </>
          )}

          <Route exact path="van">
            <Route path="dashboard" element={<VanDashbaordIndex />} />
            <Route path="transaction" element={<VanTransactionIndex />} />
            <Route path="customer" element={<VanCustomersIndex />} />
            <Route path="finance" element={<VanFinanceIndex />} />
          </Route>
        </>
      ) : (
        <>
          <Route path="/resetpassword" element={<CreatePasswordIndex />} />
          <Route path="/login" element={<LoginIndex />} />
          <Route path="/forgotpassword" element={<ForgotPasswordIndex />} />
          <Route path="*" element={<Navigate to="/login" />} />
          <Route path="/verify" element={<Verified2fa />} />
        </>
      )}
    </Routes>
  );
}

export default RouteIndex;
